export const paths = {
  LearnMoreSYT: 'https://docs.autohodl.money/spendable-yield-tokens',
  GetMetaMaskCard: 'https://metamask.io/card',
  Arbitrum: 'https://devfolio.co/projects/auto-hodl-e5dd',
  Base: 'https://devfolio.co/projects/auto-hodl-e5dd',
  MetaMask: 'https://x.com/MetaMaskDev/status/1950918297483948491',
  Circle: 'https://x.com/BuildOnCircle/status/1985381981748916486',
};

export const links = {
  telegram: 'https://t.me/+713AuddkI9phNjUx',
  twitter: 'https://x.com/autoHODL',
  github: 'https://github.com/locker-labs/autohodl.money',
  contact: 'mailto:hello@autohodl.money',
  docs: 'https://docs.autohodl.money',
  perch: 'https://perch.bio/autohodl',
};

export const legalPaths = {
  terms: '/terms',
  privacy: '/privacy',
};
